import { handleActions } from 'redux-actions';
import * as performersActions from '../../actions/performers/getAllPerformers';

let initialState = {
  performers: [],
  loading: false,
  errorMessage: '',
};

export const performers = handleActions(
  {
    //  get profile info
    [performersActions.getAllPerformers]: (state, action) => {
      return { ...state, loading: true };
    },
    [performersActions.getAllPerformersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        performers: payload.performers,
        performerTypes: payload.performerTypes,
        performersStat: payload.performersStat,
        loading: false,
      };
    },
    [performersActions.getAllPerformersFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
  },
  initialState
);
